import { set, toggle } from '@/utils/vuex'

export default {
  loadWorkloadByOppId (state, workloads) {
    state.workloads = workloads
  },
  loadWorkloadContactInfo (state, contact) {
    state.newAwsAccount.accountRecord.contact = contact
    // state.workload.opportunity = workload.opportunity !== undefined ? workload.opportunity : state.workload.opportunity
  },
  loadEmail (state, emails) {
    state.requestorContactInfo = {
      ...state.requestorContactInfo,
      emails: emails
    }
  },
  loadOnboardingInfo (state, onboardingId) {
    state.workload.onboarding.Onboarding_Id = onboardingId
  },
  loadCustomers (state, customers) {
    state.customers = customers
  },
  updateCustomers(state, data) {
    state.customers.push(data)
  },
  setCustomerAlias(state, alias) {
    console.log('setAlias: '+ alias )
    state.awsAccountOnboarding.fields.Customer_Alias = alias
  },
  setFormStateContacts (state, data) {
    state.showRequestAwsQuestionnaire = false
    state.showRequestAwsContacts = true
  },

  setSearchSfdcId (state, id) {
    state.newAwsAccount = {
      ...state.newAwsAccount,
      sfdcId: id
    }
  },

  setNewSelectedContact (state, contact) {
    state.newAwsAccount = {
      ...state.newAwsAccount,
      accountRecord: {
        ...state.newAwsAccount.accountRecord,
        contact: { ...contact }
      }
    }
  },

  setWorkloads (state, workloads) {
    state.awsAccountListing = {
      ...state.awsAccountListing,
      workloads: workloads
    }
  },

  setRestrictedRegions(state, regions) {
    state.restrictedRegions = regions
  },

  setOnboardingRecords(state, records) {
    state.onboardingRecords = records
  },

  setRequestorContactInfo(state, contact) {
    state.newAwsAccount = {
      ...state.newAwsAccount,
      accountRecord: {
        ...state.newAwsAccount.accountRecord,
        contact: { ...contact }
      }
    }
  },
  setNewAcctOnboardingStatus(state, status) {
    state.newAwsAccount.accountRecord.onboarding.Onboarding_Status = status
  },
  clearNewAccount(state) {
    state.newAwsAccount = {
      ...state.newAwsAccount,
      registrationStep: 'listing', // ie, listing, validation, onboarding, contact
      searching: false,
      searchMessage: '',
      searchError: false,
      selected: false,
      opportunityName: '',
      workloadTitle: '',
      submittedDate: '',
      oppregStatus: '',
      // sfdcId: '',
      accountRecord: {
        financial: {
          WBS_code: null,
          WBS_expiration_date: null,
          IWO_Reqd: null,
          IWO_Code: null,
          IWO_expiration_date: null
        },
        onboarding: {
          Onboarding_Id: null,
          Acct_ID: null,
          Acct_Exp_Id: null,
          Onboarding_Status: 'New',
          Financial_Id: null,
          Unique_Agreement_Id: null,
          AcctSecurity_Id: null,
          Customer_Id: null,
          Project_Id: null,
          Contact_Id: null,
          Customer_Type: null,
          Client_Shortname: null,
          Cust_Shortname: null,
          Acct_name: null,
          Acct_DL: null,
          Date_onboarded: null,
          Last_Date_Validated: null,
          Date_Requested_change: null,
          MP_ID: null,
          Previous_MP_ID: null,
          Managed_Svc: null,
          Acct_status: null,
          Acct_Restricted: null,
          Is_MP: null,
          Acct_Description: null,
          Del_Flag: 0,
          Account_Purpose: null,
          AWS_Support_Type: null,
          Specific_Region: null,
          Specific_Location: null,
          Account_Owners: [],
          CloudCheckr_users: [],
          IAM_Users: [],
          Notification_List: [],
          Financial_Owner: [],
          Customer_Regulations: [],
          Comments: null,
          SaaS: null,
          SaaS_Solution: null,
          AWS_Req_Type:null,
          Restricted_Region_Id: null, 
          Tmp_Cust_Name: null,
          Registration_Id: null,
          GovCloud_Resource_Account: null
        },
        contact: {
        }
      },
      noDiscount: false
    }
  },

  clearAwsAccountListing (state) {
    state.awsAccountListing = {
      ...state.awsAccountListing,
      selectedWorkload: [],
      loadingWorkloads: false,
      workloads: []
    }
  },

  clearOnboardingQuestionnaire (state) {
    state.awsAccountOnboarding = {
      Region: false,
      isLocationSpecific: false,
      requireRegulations: 0,
      regulationsDialog: false,
      Customer_Regulations: [],
      AWS_Purpose: {
        all: [],
        primary: null,
        other: [],
        poc: {
          q1: null,
          q2: null,
          q3: null,
          q4: null,
          q5: null
        }
      },
      Client_Shortname: null,
      fields: {
        Onboarding_Id: null,
        Acct_ID: null,
        Acct_Exp_Id: null,
        Financial_Id: null,
        Unique_Agreement_Id: null,
        AcctSecurity_Id: null,
        Customer_Id: null,
        Project_Id: null,
        Contact_Id: null,
        Customer_Type: null,
        Client_Shortname: null,
        Cust_Shortname: null,
        Acct_name: null,
        Acct_DL: null,
        Date_onboarded: null,
        Last_Date_Validated: null,
        Date_Requested_change: null,
        MP_ID: null,
        Previous_MP_ID: null,
        Managed_Svc: null,
        Acct_status: null,
        Acct_Restricted: null,
        Is_MP: null,
        Acct_Description: null,
        Del_Flag: 0,
        Account_Purpose: null,
        AWS_Support_Type: null,
        Specific_Region: null,
        Specific_Location: null,
        Account_Owners: [],
        CloudCheckr_users: [],
        IAM_Users: [],
        Notification_List: [],
        Financial_Owner: [],
        Customer_Regulations: [],
        Comments: null,
        SaaS: null,
        SaaS_Solution: null,
        AWS_Req_Type:null,
        Restricted_Region_Id: null, 
        Tmp_Cust_Name: null,
        Is_Training_Account: 'No',
        GovCloud_Resource_Account: null
      }
    }
  },

  clearAwsAccountContacts (state) {
    state.awsAccountContact = {
      accountOwnersHeaders: [
        {
          text: 'Actions',
          value: 'Actions',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Name',
          value:'name'
        },
        {
          text: 'Phone',
          value: 'phone'
        },
        {
          text: 'Email',
          value: 'email'
        }
      ],
      editDialog:false,
      editedIndex: -1,
      acctOwner: {
        name: null,
        phone: null,
        email: null
      },
      submitting: false,
      submitted: false,
      contactStatus: false,
      contactStatusMsg: null,
      Account_Owners: [],
      awsContactValid: true

    }
  },

  clearSelectedWorkload (state) {
    state.selectedWorkload = []
  },

  setSearchResponse (state, response) {
    state.newAwsAccount = {
      ...state.newAwsAccount,
      searchError: response.error,
      searchMessage: response.message
    }
  },

  savingContact (state, loading) {
    state.newAwsAccount = {
      ...state.newAwsAccount,
      savingContact: loading
    }
  },

  setSelectedWorkload (state, workload) {
    let selWorkload = workload.length ? [workload.slice(-1)[0]] : []
    console.log('selWorkload: '+ selWorkload)
    state.awsAccountListing = {
      ...state.awsAccountListing,
      selectedWorkload: selWorkload
    }

    state.newAwsAccount = {
      ...state.newAwsAccount,
      workloadTitle: selWorkload[0].Workload_Title,
      submittedDate: selWorkload[0].OppReg_Req_Date,
      oppregStatus: selWorkload[0].Workload_Status,
      workloadType: selWorkload[0].Workload_type
    }
    state.newAwsAccount.accountRecord.onboarding.Registration_Id = selWorkload[0].Registration_Id
    // state.workload.questionnaire.Project_Id = workload.length ? workload.slice(-1)[0].Project_Id : null
  },

  setNoDiscountMessage (state, display) {
    state.newAwsAccount.noDiscount = display

    console.log('DONT KNOW YET')

  },

  updateOnboardingProjectId (state, id) {
    state.newAwsAccount.accountRecord.onboarding.Project_Id = id
  },
  setLoadingWorkloads (state, searching) {
    state.newAwsAccount.searching = searching
  },

  setWorkloadRecord (state, workload) {
    state.newAwsAccount = {
      ...state.newAwsAccount,
      ...workload
    }
  },

  setWorkloadCustName (state, customername){
    state.awsAccountOnboarding.fields = {
      ...state.awsAccountOnboarding.fields, 
      ...customername
    }
  },

  setRegistrationStep(state, step) {
    state.newAwsAccount.registrationStep = step
  },

  updateOnboardingContactId (state, id) {
    state.newAwsAccount.accountRecord.contact.Id = id
    state.newAwsAccount.accountRecord.onboarding.Contact_Id = id
  },

  resetWbsValidation (state) {
    state.awsAccountValidation = {
      ...state.awsAccountValidation,
      wbsValidating: false,
      wbsValidationMessage: '',
      wbsCodeValidated: false,
      wbsType: null,
      iwoCode: null,
      iwoValidating: false,
      iwoValidationMessage: '',
      iwoCodeValidated: false,
      agreed: false,
      submitting: false,
      savingForLater: false
    }
  },

  clearValidation (state) {
    state.awsAccountValidation = {
      wbsCode: null,
      wbsValidating: false,
      wbsValidationMessage: '',
      wbsCodeValidated: false,
      wbsType: null,
      iwoCode: null,
      iwoValidating: false,
      iwoValidationMessage: '',
      iwoCodeValidated: false,
      agreed: false,
      submitting: false,
      savingForLater: false
    }
  },

  setWbsCodeValidating (state, loading) {
    state.awsAccountValidation = {
      ...state.awsAccountValidation,
      wbsValidating: loading
    }
  },

  setIwoCodeValidating (state, loading) {
    state.awsAccountValidation = {
      ...state.awsAccountValidation,
      iwoValidating: loading
    }
  },

  setWbsValidationResponse (state, response) {
    if (response.valid) {
      state.awsAccountValidation = {
        ...state.awsAccountValidation,
        wbsCodeValidated: true,
        wbsValidationMessage: response.message,
        wbsType: response.type
      }
    } else {
      state.awsAccountValidation = {
        ...state.awsAccountValidation,
        wbsCodeValidated: false,
        wbsType: '',
        wbsValidationMessage: response.message
      }
    }
  },
  setIwoValidationResponse (state, response) {
    if (response.valid) {
      state.awsAccountValidation = {
        ...state.awsAccountValidation,
        iwoCodeValidated: true,
        iwoValidationMessage: response.message
      }
    } else {
      state.awsAccountValidation = {
        ...state.awsAccountValidation,
        iwoCodeValidated: false,
        iwoValidationMessage: response.message
      }
    }
  },
  wbsValidationSubmitting (state, loading) {
    state.awsAccountValidation = {
      ...state.awsAccountValidation,
      submitting: loading
    }
  },
  setOnboardingFinancialId (state, id) {
    state.newAwsAccount.accountRecord.onboarding.Financial_Id = id
  },
  // Onboarding
  updateOnboarding (state, data) {
    state.newAwsAccount.accountRecord.onboarding = {
      ...state.newAwsAccount.accountRecord.onboarding,
      Acct_name: data.Acct_name,
      Specific_Region: data.Specific_Region,
      Specific_Location: data.Specific_Location,
      Acct_Description: data.Acct_Description,
      Account_Purpose: data.Account_Purpose,
      Managed_Svc: data.Managed_Svc,
      AWS_Support_Type: data.AWS_Support_Type,
      Customer_Regulations: data.Customer_Regulations,
      SaaS: data.SaaS,
      SaaS_Solution: data.SaaS_Solution,
      Client_Shortname: data.Client_Shortname,
      Cust_Shortname: data.Cust_Shortname,
      Tmp_Cust_Name: data. Tmp_Cust_Name,
      AWS_Req_Type:data.AWS_Req_Type,
      Restricted_Region_Id: data.Restricted_Region_Id,
      GovCloud_Resource_Account: data.GovCloud_Resource_Account

    }
  },
  updateOnboardingFields(state, data){

    console.log('***********  updateOnboardingFields  *************')
    console.log(data)
    console.log('**************************************************')

    state.newAwsAccount.accountRecord.onboarding = {
      ...state.newAwsAccount.accountRecord.onboarding,
      Acct_name: data.fields.data.Acct_name,
      Specific_Region: data.fields.data.Specific_Region,
      Specific_Location: data.fields.data.Specific_Location,
      Acct_Description: data.fields.data.Acct_Description,
      Account_Purpose: data.fields.data.Account_Purpose,
      Managed_Svc: data.fields.data.Managed_Svc,
      AWS_Support_Type: data.fields.data.AWS_Support_Type,
      Customer_Regulations: data.fields.data.Customer_Regulations,
      SaaS: data.fields.data.SaaS,
      SaaS_Solution: data.fields.data.SaaS_Solution,
      Client_Shortname: data.fields.data.Client_Shortname,
      Cust_Shortname: data.fields.data.Cust_Shortname,
      Tmp_Cust_Name: data.fields.data. Tmp_Cust_Name,
      AWS_Req_Type:data.fields.data.AWS_Req_Type,
      Restricted_Region_Id: data.fields.data.Restricted_Region_Id, 
      MP_ID: data.mpid,
      GovCloud_Resource_Account: data.GovCloud_Resource_Account

    }
  },

  updateOnboardingContacts (state, contacts) {
    state.newAwsAccount.accountRecord.onboarding.Account_Owners = contacts.accountOwners ? JSON.stringify(contacts.accountOwners) : '[]'
    state.newAwsAccount.accountRecord.onboarding.CloudCheckr_users = contacts.cloudchekrUsers ? JSON.stringify(contacts.cloudchekrUsers.map(record => record)) : '[]'
    state.newAwsAccount.accountRecord.onboarding.Notification_List = contacts.notificationList ? JSON.stringify(contacts.notificationList.map(record => record)) : '[]'
    state.newAwsAccount.accountRecord.onboarding.IAM_Users = contacts.iamUsers ? JSON.stringify(contacts.iamUsers.map(record => record)) : '[]'
    state.newAwsAccount.accountRecord.onboarding.Financial_Owner = contacts.financeOwners ? JSON.stringify(contacts.financeOwners.map(record => record)) : '[]'
  },

  onboardingAccount (state, loading) {
    state.awsAccountContact = {
      ...state.awsAccountContact,
      submitting: loading,
      submitted: !loading
    }
  },

  savingForLater (state, loading) {
    state.awsAccountValidation = {
      ...state.awsAccountValidation,
      savingForLater: loading,
      savedForLater: !loading
    }
  },

  setWorkloadLoading (state, data) {
    state.loadingWorkload = data
  },
  setloadingRequestorContactInfo (state, data) {
    state.loadingRequestorContactInfo = data
  },
  setloadingEmailData (state, data) {
    state.requestorContactInfo.loadingEmailData = data
  },
  checkOnboardingContactsStatus (state, data) {
    if (data) {
      if (data.status === 200) {
        state.workload.onboarding.contactStatus = true
        state.workload.onboarding.contactStatusMsg = 'You have successfully saved contact info!'
      } else {
        state.workload.onboarding.contactStatus = true
        state.workload.onboarding.contactStatusMsg = 'Error have been encountered on submitting onboarding contact information.'
      }
    }
  },
  setWorkloadStatus (state, data) {
    state.workload.questionnaire.Workload_Status = data
  },
  resetRequestAWS (state, data) {
    state.sfdcId = null
    state.workloads = []
    state.registrationStep = 'listing'
    state.selectedWorkload = []
    state.workload = {
      emailAddress: null,
      Region: false,
      isLocationSpecific: false,
      questionnaire: {
        Project_Id: null,
        OppReg_Id: null,
        Registration_Id: null,
        Contact_Id: null,
        SFDC_Id: null,
        Workload_Title: null,
        VMware_Workload: null,
        VMware_License: null,
        VMware_Cust_Deploy: null,
        Workload_type: null,
        PPA_Attestation: null,
        Root_Access: null,
        DXC_Managed_Services: null,
        SaaS: null,
        Initiate_Account_Flag: null,
        Workload_Services_Storage: null,
        Workload_Services_Database: null,
        Workload_Services_App_services: null,
        Workload_Services_Compute: null,
        Workload_Services_Network: null,
        Projected_Monthly_Spend: null,
        WL_Overall_Objective: null,
        WL_Scope_Bounderies: null,
        WL_App_Transformed: null,
        WL_Next_Pursuit: null,
        WL_Q5: null,
        WL_Q6: null,
        OppReg_Project_Notes: null,
        OppReg_Req_Date: null,
        Workload_Status: null,
        Workload_Description: null
      },
      contact: {
        Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Phone: null,
        Contact_Email: null,
        Contact_Title: null,
        Contact_FullName: null

      },
      newContact: {
        Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Phone: null,
        Contact_Email: null,
        Contact_Title: null,
        Contact_FullName: null
      },
      opportunity: {
        Opportunity_Id: null,
        SFDC_Oppty_Name: null,
        SFDC_Sales_Stage: null,
        SignDate: null,
        OpportunityTotalValueUSD: null,
        ESRegion: null,
        Customer_Name: null,
        Country: null,
        PrimaryESPracticeName: null,
        OpportunityDescription: null,
        OpportunityStatus: null,
        IndustryVertical: null,
        ContractLength: null,
        Opportunity_Number: null,
        Client_ID: null
      },
      onboarding: {
        Onboarding_Id: null,
        Acct_ID: null,
        Acct_Exp_Id: null,
        Financial_Id: null,
        Unique_Agreement_Id: null,
        AcctSecurity_Id: null,
        Customer_Id: null,
        // Ext_Account_Id: null,
        Project_Id: null,
        Contact_Id: null,
        Customer_Type: null,
        Acct_name: null,
        Acct_DL: null,
        Date_onboarded: null,
        Last_Date_Validated: null,
        Date_Requested_change: null,
        MP_ID: null,
        Previous_MP_ID: null,
        Managed_Svc: null,
        Acct_status: null,
        Acct_Restricted: null,
        Is_MP: null,
        Acct_Description: null,
        Del_Flag: null,
        Account_Purpose: null,
        AWS_Support_Type: null,
        Specific_Region: null,
        Specific_Location: null,
        Account_Owners: [],
        CloudCheckr_users: [],
        IAM_Users: [],
        Notification_List: [],
        Financial_Owner: [],
        AWS_Purpose: {
          all: [],
          primary: null,
          other: [],
          poc: {
            q1: null,
            q2: null,
            q3: null,
            q4: null,
            q5: null
          }
        },
        Customer_Regulations: [],
        // accountOwners: [],
        acctOwner: {
          name: null,
          phone: null,
          email: null
        },
        contactStatus: false,
        contactStatusMsg: null,
        GovCloud_Resource_Account: null
      }
    }
  },
  //  REQUEST NEW AWS ACCOUNT FOR EXISTING CLIENT
  setCustomers (state, data) {
    state.newAwsAcctExistingClient.customers = data
  },
  setMasterPayers(state, data) {
    state.newAwsAcctExistingClient.masterpayers = data
  },
  setAcctsLoading (state, data) {
    state.newAwsAcctExistingClient.awsAccountListing.loadingAccts = data
  },
  setCustomerOnboarding (state, data) {
    state.newAwsAcctExistingClient.awsAccountListing.existingAccounts = data
  },
  setCustomerAgreement (state, data) {
    state.newAwsAcctExistingClient = {
      ...state.newAwsAcctExistingClient,
      agreement: data
    
    }
  },
  setExistingDialog1(state, data){
    console.log('::: setExistingDialog1 :::')
    console.log(data.dialog)
    console.log('::::::::::::::::::::::::::')
    state.newAwsAcctExistingClient.existingDialog1 = data
    console.log('mon: ',state.newAwsAcctExistingClient.existingDialog1)
  },
  setCustomOnboardingDialog(state, data) {
    state.newAwsAcctExistingClient.customOnboardingDialog = data.dialog
    state.newAwsAcctExistingClient.dialog = data.seldialog
    state.newAwsAcctExistingClient.next = data.next
  },
  setOppIdExistsLoading (state, data) {
    if(data.awsType ==='internal') {
      state.newAwsAcctInternalClient.OppRegIdExistLoading = data.loading
    }
    if(data.awsType === 'external') {
      state.newAwsAcctExistingClient.OppRegIdExistLoading = data.loading
    }
  },

  setOppRegIdAvailabilityMessage(state, data){
    if(data.awsType === 'internal'){
      if(data.type === 'success'){
        state.newAwsAcctInternalClient = {
          ...state.newAwsAcctInternalClient, 
          OppregIdValidated:true,
          OppRegIdExistError: false, 
          OppRegIdExistErrorMessage:[], 
          OppRegIdExistSuccess: true, 
          OppRegIdExistSuccessMessage: [data.message],
        }
      } else {
        state.newAwsAcctInternalClient = {
          ...state.newAwsAcctInternalClient, 
          OppregIdValidated: false,
          OppRegIdExistError: true, 
          OppRegIdExistErrorMessage:[data.message], 
          OppRegIdExistSuccess: false, 
          OppRegIdExistSuccessMessage: [],
        }
      }
    }

    if(data.awsType ==='external'){
      if(data.type === 'success'){
        state.newAwsAcctExistingClient = {
          ...state.newAwsAcctExistingClient, 
          OppregIdValidated:true,
          OppRegIdExistError: false, 
          OppRegIdExistErrorMessage:[], 
          OppRegIdExistSuccess: true, 
          OppRegIdExistSuccessMessage: [data.message],
        }
      } else {
        state.newAwsAcctExistingClient = {
          ...state.newAwsAcctExistingClient, 
          OppregIdValidated:false,
          OppRegIdExistError: true, 
          OppRegIdExistErrorMessage:[data.message], 
          OppRegIdExistSuccess: false, 
          OppRegIdExistSuccessMessage: [],
        }
      }
    }
    
  },
  setWorkloadsByOppRegId (state, data) {
    state.newAwsAcctExistingClient.workloads = data
  },

  setGeneratingOppId(state, loading) {
    state.newAwsAcctInternalClient.generatingOppId = loading
  },

  setInternalOpportunityId(state, id) {
    state.newAwsAcctInternalClient.oppId = id
    state.newAwsAcctInternalClient.workload.oppFields.opportunity.Opportunity_Id = id
    state.newAwsAcctInternalClient.workload.oppFields.opportunity.OppReg_Id = id
    state.newAwsAcctInternalClient.workload.fields.SFDC_Id = id
    state.newAwsAcctInternalClient.workload.fields.OppReg_Id = id
  },

  setLoadingCustomers(state, loading) {
    state.newAwsAcctInternalClient.loadingCustomers = loading
  },

  clearInternalProjectId(state) {
    state.newAwsAcctInternalClient.projectId = ''
  },

  clearInternalWorkload(state) {
    state.newAwsAcctInternalClient.workload.fields.Workload_Title = ''
  },

  clearInternalContact(state) {
    state.newAwsAcctInternalClient.workload.sameAsLoggedInUser = false
    state.newAwsAcctInternalClient.workload.contact = {
      Id: null,
      Contact_First_Name: null,
      Contact_Last_Name: null,
      Contact_Email: null,
      Contact_Phone: null
    }
  },

  updateInternalOnboardingContact(state, id) {
    state.newAwsAcctInternalClient.accountRecord.onboarding.Contact_Id = id
  },

  clearInternalOppId(state) {
    state.newAwsAcctInternalClient.oppId = ''
    state.newAwsAcctInternalClient.workload.oppFields.account = {
      Client_ID: null,
      Customer_Id: null,
      Customer_Name: null,
      Customer_Region: null,
      Customer_URL: null,
      Customer_Address: null,
      Customer_City: null,
      Customer_State: null,
      Customer_PC: null,
      Industry: null
    }
  },

  setInternalOnboardCustomerId(state, id) {
    state.newAwsAcctInternalClient.accountRecord.onboarding.Customer_Id = id

  },
  setRegistrationId(state) {
    let registrationId = state.newAwsAcctInternalClient.workload.fields.Workload_Title.replaceAll(' ','-') + state.newAwsAcctInternalClient.workload.fields.SFDC_Id;
    state.newAwsAcctInternalClient.workload.fields.Registration_Id = registrationId
    state.newAwsAcctInternalClient.accountRecord.onboarding.Registration_Id = registrationId
  },

  updateInternalRegistrationProjectId(state, id) {
    state.newAwsAcctInternalClient.projectId = id
    state.newAwsAcctInternalClient.accountRecord.onboarding.Project_Id = id
  },

  updateOppId(state, id) {
    state.newAwsAcctInternalClient.oppId = id
  },

  setWorkloadContact (state, user) {
    state.newAwsAcctInternalClient.workload.contact = {
      Contact_Id: user.Id,
      Contact_Last_Name: user.Contact_Last_Name,
      Contact_First_Name: user.Contact_First_Name,
      Contact_Email: user.Contact_Email,
      Contact_Phone: user.Contact_Phone
    }
  },

  clearWorkloadContact (state) {
    state.newAwsAcctInternalClient.workload.contact = {
      Contact_Id: null,
      Contact_Last_Name: null,
      Contact_First_Name: null,
      Contact_Email: null,
      Contact_Phone: null
    }
  },

  setAllWorkloadsByOppregId(state, data) {
    if(data.awsType === 'internal') {
      state.newAwsAcctInternalClient.workloads = data.workloads
    }
    if(data.awsType === 'external') {
      state.newAwsAcctExistingClient.workloads = data.workloads
    }
  },
  setSelectedCustomerAgreement(state, agreement){
    console.log('setSelectedCustomerAgreement:: ',agreement)
    state.newAwsAcctExistingClient.selectedCustomerAgreement = agreement
  },
  setSelecteNoRegIdAcct(state,account){
    console.log('----- mutation: setSelecteNoRegIdAcct -----')
    console.log(account)
    console.log(account.mirrorAcct)
    console.log(account.projectId)
    console.log(account.workloadType)
    console.log('Workload Status: ', account.Workload_Status)
    console.log(account.selCustAgreement)
    console.log('----------------------------------------')
    if(account.mirrorAcct === 'Y') {
    console.log('aa')
    state.newAwsAcctExistingClient = {
      ...state.newAwsAcctExistingClient,
      agreement: account.Agreement,
      // AcctSecurity_Id: account.AcctSecurity_Id,
      Acct_ID: account.Acct_ID,
      Acct_name: account.Acct_name,
      Contact_Id: account.Contact_Id,
      Customer_Id: account.Customer_Id,
      Customer_Name: account.Customer_Name,
      Customer_Alias: account.Customer_Alias,
      Financial_Id: account.Financial_Id,
      MP_ID: null,
      Onboarding_Id: account.Onboarding_Id,
      Project_Id: account.projectId,
      Registration_Id: account.Registration_Id,
      Unique_Id: account.Unique_Id,
      Workload_Status: account.workloadTypeWorkload_Status,
      Workload_Type: account.workloadType,
      Workload_Status: account.Workload_Status,
      
    }
    console.log('AccountID: '+ account.Acct_ID)

    if(account.Acct_ID !== 'None'){
      state.newAwsAcctExistingClient.accountRecord.onboarding = {
        ...state.newAwsAcctExistingClient.accountRecord.onboarding,
        // AcctSecurity_Id: account.AcctSecurity_Id,
        Customer_Id: account.Customer_Id,
        Contact_Id: account.Contact_Id,
        MP_ID: null,
        Project_Id: account.projectId,
        Unique_Agreement_Id: account.Unique_Id,
        Additional_Acct: account.mirrorAcct
      }
    } else {
      state.newAwsAcctExistingClient.accountRecord.onboarding = {
        ...state.newAwsAcctExistingClient.accountRecord.onboarding,
        // AcctSecurity_Id: account.AcctSecurity_Id,
        Customer_Id: account.Customer_Id,
        Contact_Id: account.Contact_Id,
        Project_Id: account.projectId,
        Unique_Agreement_Id: account.Unique_Id,
        Additional_Acct: account.mirrorAcct,
        MP_ID: null
      }
    }
 
  } else {
    console.log('bb')
    console.log('--------- fields needs in mp id ---------')
    console.log(account)
    let workloadStatus,supportType, isSaas
    // console.log(state.newAwsAcctExistingClient.)
    console.log('-----------------------------------------')
    if(account.selCustAgreement === undefined){
      account.selCustAgreement = ''
    }
    state.newAwsAcctExistingClient = {
      ...state.newAwsAcctExistingClient,
      Customer_Id: account.Customer_Id,
      Customer_Alias: account.Customer_Alias,
      Project_Id: account.projectId,
      Workload_Type: account.workloadType,
      Workload_Status: account.Workload_Status,
      selectedCustomerAgreement: account.selCustAgreement
    }

    state.newAwsAcctExistingClient.accountRecord.onboarding = {
      ...state.newAwsAcctExistingClient.accountRecord.onboarding, 
      Customer_Id: account.Customer_Id,
      Project_Id: account.projectId,
      Additional_Acct: account.mirrorAcct
    }
  }

  },
  setSelectedAccount (state, account) {
    console.log('--------- mutation: setSelectedAccount ----------')
    console.log(account)
    console.log('--------------------------------------------------')
    state.newAwsAcctExistingClient = {
      ...state.newAwsAcctExistingClient,
      agreement: account.Agreement,
      // AcctSecurity_Id: account.AcctSecurity_Id,
      Acct_ID: account.Acct_ID,
      Acct_name: account.Acct_name,
      Contact_Id: account.Contact_Id,
      Customer_Id: account.Customer_Id,
      Customer_Name: account.Customer_Name,
      Customer_Alias: account.Customer_Alias,
      Financial_Id: account.Financial_Id,
      MP_ID: account.MP_ID,
      Onboarding_Id: account.Onboarding_Id,
      Project_Id: account.Project_Id,
      Registration_Id: account.Registration_Id,
      Unique_Id: account.Unique_Id,
      Workload_Status: account.Workload_Status,
      Workload_Type: account.Workload_Type
    }

    let selAcctProjectId = account.Project_Id
    if (selAcctProjectId === "None") {
      selAcctProjectId = ''
    } 


    console.log('selAcctProjectId: '+ selAcctProjectId)


    state.newAwsAcctExistingClient.accountRecord.onboarding = {
      ...state.newAwsAcctExistingClient.accountRecord.onboarding,
      // AcctSecurity_Id: account.AcctSecurity_Id,
      Customer_Id: account.Customer_Id,
      Contact_Id: account.Contact_Id,
      MP_ID: account.MP_ID,
      Project_Id: selAcctProjectId,
      Unique_Agreement_Id: account.Unique_Id
    }
    

  },
  setExistingRegistrationStep (state, step) {
    state.newAwsAcctExistingClient.registrationStep = step
  },
  setExistingLanding (state, data) {
    console.log("===============================")
    console.log(data)
    console.log("================================")
    if(data.dialog === 'dialog1'){
      state.newAwsAcctExistingClient.existingDialog1 = data.status
    } 

    if(data.dialog === 'dialog2'){
      state.newAwsAcctExistingClient.existingDialog2 = data.status
    } 
    
    state.newAwsAcctExistingClient.dialog = data.dialog
    state.newAwsAcctExistingClient.landing = data.landing
  },
  // Onboarding
  updateOnboardingExisting (state, data) {
    state.newAwsAcctExistingClient.accountRecord.onboarding = {
      ...state.newAwsAcctExistingClient.accountRecord.onboarding,
      Acct_name: data.Acct_name,
      Specific_Region: data.Specific_Region,
      Specific_Location: data.Specific_Location,
      Acct_Description: data.Acct_Description,
      Account_Purpose: data.Account_Purpose,
      Managed_Svc: data.Managed_Svc,
      AWS_Support_Type: data.AWS_Support_Type,
      Customer_Regulations: data.Customer_Regulations,
      SaaS: data.SaaS,
      SaaS_Solution: data.SaaS_Solution,
      Client_Shortname: data.Client_Shortname,
      Cust_Shortname: data.Cust_Shortname,
      AWS_Req_Type:data.AWS_Req_Type,
      Restricted_Region_Id: data.Restricted_Region_Id,
      GovCloud_Resource_Account:data.GovCloud_Resource_Account
    }
  },
  updateOnboardingContactsExisting (state, contacts) {

    state.newAwsAcctExistingClient.accountRecord.onboarding.Account_Owners = contacts.accountOwners ? JSON.stringify(contacts.accountOwners) : '[]'
    state.newAwsAcctExistingClient.accountRecord.onboarding.CloudCheckr_users = contacts.cloudchekrUsers ? JSON.stringify(contacts.cloudchekrUsers.map(record => record)) : '[]'
    state.newAwsAcctExistingClient.accountRecord.onboarding.Notification_List = contacts.notificationList ? JSON.stringify(contacts.notificationList.map(record => record)) : '[]'
    state.newAwsAcctExistingClient.accountRecord.onboarding.IAM_Users = contacts.iamUsers ? JSON.stringify(contacts.iamUsers.map(record => record)) : '[]'
    state.newAwsAcctExistingClient.accountRecord.onboarding.Financial_Owner = contacts.financeOwners ? JSON.stringify(contacts.financeOwners.map(record => record)) : '[]'
  },
  clearExistingOppregIdModal (state) {
     state.newAwsAcctExistingClient = {
       ...state.newAwsAcctExistingClient, 
       errorDialog2: false,
   
       nextStatus: true,
       existingDialog1: false,
   
       // modal on AwsCustomOnboardingList
       customOnboardingDialog: false,
       next: true,
       q1: null,
       q2: null,
       OppRegId:'',
       OppRegIdExistLoading:false,
       OppRegIdExistError: false, 
       OppRegIdExistErrorMessage:[], 
       OppRegIdExistSuccess: false, 
       OppRegIdExistSuccessMessage: [],
       workloads:[],
       projectId: ''
      }
  },
  clearExistingAccount (state) {
    state.newAwsAcctExistingClient = {
      ...state.newAwsAcctExistingClient,
      landing: true,
      registrationStep: 'listing', // ie, listing, validation, onboarding, contact
      isCustomerFound: false,
      isAdditionalAcctSupport: null,
      customers: [],
      masterpayers:[], 
      selectedCustomer: null,
      selectedCustomerAgreement: '',
      errorDialog1: false,
      errorDialog2: false,
      agreement: null,
      nextStatus: true,
      existingDialog1: false,  
  
      // modal on AwsCustomOnboardingList
      customOnboardingDialog: false,
      next: true,
      q1: null,
      q2: null,
      OppRegId:'',
      OppregIdValidated: false,
      OppRegIdExistLoading:false,
      OppRegIdExistError: false, 
      OppRegIdExistErrorMessage:[], 
      OppRegIdExistSuccess: false, 
      OppRegIdExistSuccessMessage: [],
      workloads:[],
      projectId: '',
  
      AcctSecurity_Id: null,
      Acct_ID: null,
      Acct_name: null,
      Contact_Id: null,
      Customer_Id: null,
      Customer_Name: null,
      Customer_Alias: null,
      Financial_Id: null,
      MP_ID: null,
      Onboarding_Id: null,
      Project_Id: null,
      Registration_Id: null,
      Unique_Id: null,
      Workload_Status: null,
      Workload_Type: null,
      awsAccountListing: {
        selectedWorkload: [],
        loadingAccts: false,
        accountHeaders: [
          {
            sortable: true,
            text: 'Actions',
            value: ''
          },
          {
            sortable: true,
            text: 'Account ID',
            value: 'Acct_ID'
          },
          {
            sortable: true,
            text: 'Account Name',
            value: 'Acct_name'
          },
          {
            sortable: true,
            text: 'Master Payer ID',
            value: 'MP_ID'
          },
          {
            sortable: true,
            text: 'Registration ID',
            value: 'Registration_Id'
          },
          {
            sortable: true,
            text: 'OppReg Status',
            value: 'OppReg_Status'
          }
        ],
        existingAccounts: []
      },
      accountRecord: {
        financial: {
          WBS_code: null,
          WBS_expiration_date: null,
          IWO_Reqd: null,
          IWO_Code: null,
          IWO_expiration_date: null
        },
        onboarding: {
          Onboarding_Id: null,
          Onboarding_Status: 'New',
          Acct_ID: null,
          Acct_Exp_Id: null,
          Financial_Id: null,
          Unique_Agreement_Id: null,
          AcctSecurity_Id: null,
          Customer_Id: null,
          Project_Id: null,
          Contact_Id: null,
          Customer_Type: null,
          Client_Shortname:null, 
          Cust_Shortname: null,
          Customer_Type: null,
          Acct_name: null,
          Acct_DL: null,
          Date_onboarded: null,
          Last_Date_Validated: null,
          Date_Requested_change: null,
          MP_ID: null,
          Previous_MP_ID: null,
          Managed_Svc: null,
          Acct_status: null,
          Acct_Restricted: null,
          Is_MP: null,
          Acct_Description: null,
          Del_Flag: 0,
          Account_Purpose: null,
          AWS_Support_Type: null,
          Specific_Region: null,
          Specific_Location: null,
          Account_Owners: [],
          CloudCheckr_users: [],
          IAM_Users: [],
          Notification_List: [],
          Financial_Owner: [],
          Customer_Regulations: [],
          Comments: null,
          SaaS: null,
          SaaS_Solution: null,
          AWS_Req_Type:null,
          Restricted_Region_Id: null, 
          WS_Selected: null,
          GovCloud_Resource_Account: null
        },
        contact: {
          Id: null,
          Contact_First_Name: null,
          Contact_Last_Name: null,
          Contact_Phone: null,
          Contact_Email: null,
          Contact_Title: null,
          Contact_FullName: null
        },
        newContact: {
          Id: null,
          Contact_First_Name: null,
          Contact_Last_Name: null,
          Contact_Phone: null,
          Contact_Email: null,
          Contact_Title: null,
          Contact_FullName: null
        }
      }
    }
  },
  clearExistingAwsAcctValidation (state) {
    state.awsAccountValidation = {
      ...state.awsAccountValidation,
      wbsCode: null,
      wbsValidating: false,
      wbsValidationMessage: '',
      wbsCodeValidated: false,
      wbsType: null,
      iwoCode: null,
      iwoValidating: false,
      iwoValidationMessage: '',
      iwoCodeValidated: false,
      agreed: false,
      submitting: false,
      savingForLater: false
    }
  },
  clearExistingAwsOnboarding (state) {
    state.awsAccountOnboarding = {
      ...state.awsAccountOnboarding,
      valid: false,
      Region: false,
      isLocationSpecific: false,
      AWS_Purpose: {
        all: [],
        primary: null,
        other: [],
        poc: {
          q1: null,
          q2: null,
          q3: null,
          q4: null,
          q5: null
        }
      },
      Client_Shortname: null,
      fields: {
        Onboarding_Id: null,
        Acct_ID: null,
        Acct_Exp_Id: null,
        Financial_Id: null,
        Unique_Agreement_Id: null,
        AcctSecurity_Id: null,
        Customer_Id: null,
        Project_Id: null,
        Contact_Id: null,
        Customer_Type: null,
        Client_Shortname:null,
        Cust_Shortname: null,
        Customer_Type: null,
        Acct_name: null,
        Acct_DL: null,
        Date_onboarded: null,
        Last_Date_Validated: null,
        Date_Requested_change: null,
        MP_ID: null,
        Previous_MP_ID: null,
        Managed_Svc: null,
        Acct_status: null,
        Acct_Restricted: null,
        Is_MP: null,
        Acct_Description: null,
        Del_Flag: 0,
        Account_Purpose: null,
        AWS_Support_Type: null,
        Specific_Region: null,
        Specific_Location: null,
        Account_Owners: [],
        CloudCheckr_users: [],
        IAM_Users: [],
        Notification_List: [],
        Financial_Owner: [],
        Customer_Regulations: [],
        Comments: null,
        AWS_Req_Type:null,
        Restricted_Region_Id: null, 
        WS_Selected: null,
        GovCloud_Resource_Account: null
      }
    }
  },
  clearExistingAwsOnboardingContacts (state) {
    state.awsAccountContact = {
      ...state.awsAccountContact,
      acctOwner: {
        name: null,
        phone: null,
        email: null
      },
      submitting: false,
      submitted: false,
      contactStatus: false,
      contactStatusMsg: null,
      Account_Owners: []
    }
  },

  // FOR INTERNAL CLIENT
  setCustomersInternal (state, data) {
    state.newAwsAcctInternalClient.customers = data.filter( res => res.Customer_Name.includes('DXC Internal') )
  },
  setInternalCustomerAlias(state, data) {
    state.newAwsAcctInternalClient.Customer_Alias = data
  },
  setWorkloadCustomer(state, customer) {
    state.newAwsAcctInternalClient.workload.oppFields.opportunity.Customer_Name = customer.Customer_Name
    state.newAwsAcctInternalClient.workload.oppFields.account.Customer_Id = customer.Customer_Id
    state.newAwsAcctInternalClient.workload.oppFields.account.Customer_Name = customer.Customer_Name
  },
  setInternalRegistrationStep (state, step) {
    state.newAwsAcctInternalClient.registrationStep = step
  },
  setInternalLanding (state, data) {
    state.newAwsAcctInternalClient.landing = data
  },
  updateOnboardingInternal (state, data) {
    state.newAwsAcctInternalClient.accountRecord.onboarding = {
      ...state.newAwsAcctInternalClient.accountRecord.onboarding,
      Acct_name: data.Acct_name,
      Specific_Region: data.Specific_Region,
      Specific_Location: data.Specific_Location,
      Acct_Description: data.Acct_Description,
      Account_Purpose: data.Account_Purpose,
      Managed_Svc: data.Managed_Svc,
      AWS_Support_Type: data.AWS_Support_Type,
      Customer_Regulations: data.Customer_Regulations,
      SaaS: data.SaaS,
      SaaS_Solution: data.SaaS_Solution,
      Client_Shortname: data.Client_Shortname,
      Cust_Shortname: data.Cust_Shortname,
      AWS_Req_Type:data.AWS_Req_Type,
      Restricted_Region_Id: data.Restricted_Region_Id,
      Is_Training_Account: data.Is_Training_Account ? data.Is_Training_Account : 'No',
      Internal_Individual_Training: data.Internal_Individual_Training,
      Manager_Name: data.Manager_Name,
      Manager_Email: data.Manager_Email,
      AWS_Service: data.AWS_Service,
      GovCloud_Resource_Account: data.GovCloud_Resource_Account
      // Customer_Id: data.Customer_Id,
      // Project_Id: data.Project_Id

    }
  },
  updateOnboardingContactsInternal (state, contacts) {

    console.log('-------- updateOnboardingContactsInternal ---------')
    console.log(contacts.notificationList)
    console.log(contacts.iamUsers)
    console.log(contacts.financeOwners)
    console.log('---------------------------------------------------')

    state.newAwsAcctInternalClient.accountRecord.onboarding.Account_Owners = contacts.accountOwners ? JSON.stringify(contacts.accountOwners) : '[]'
    state.newAwsAcctInternalClient.accountRecord.onboarding.CloudCheckr_users = contacts.cloudchekrUsers ? contacts.cloudchekrUsers : '[]'
    state.newAwsAcctInternalClient.accountRecord.onboarding.Notification_List = contacts.notificationList ? JSON.stringify(contacts.notificationList.map(record => record)) : '[]'
    state.newAwsAcctInternalClient.accountRecord.onboarding.IAM_Users = contacts.iamUsers ? JSON.stringify(contacts.iamUsers.map(record => record)) : '[]',
    state.newAwsAcctInternalClient.accountRecord.onboarding.Financial_Owner = contacts.financeOwners ? JSON.stringify(contacts.financeOwners.map(record => record)) : '[]'

    // state.newAwsAcctInternalClient.accountRecord.onboarding.Account_Owners = contacts.accountOwners ? JSON.stringify(contacts.accountOwners) : '[]'
    // state.newAwsAcctInternalClient.accountRecord.onboarding.CloudCheckr_users = contacts.cloudchekrUsers ? JSON.stringify(contacts.cloudchekrUsers.map(record => record.text)) : '[]'
    // state.newAwsAcctInternalClient.accountRecord.onboarding.Notification_List = contacts.notificationList ? JSON.stringify(contacts.notificationList.map(record => record.text)) : '[]'
    // state.newAwsAcctInternalClient.accountRecord.onboarding.IAM_Users = contacts.iamUsers ? JSON.stringify(contacts.iamUsers.map(record => record.text)) : '[]',
    // state.newAwsAcctInternalClient.accountRecord.onboarding.Financial_Owner = contacts.financeOwners ? JSON.stringify(contacts.financeOwners.map(record => record.text)) : '[]'
  },
  clearOppregId(state) {
    state.newAwsAcctInternalClient = {
      ...state.newAwsAcctInternalClient,
      oppId: '',
    OppregIdValidated: false,
    OppRegIdExistLoading: false,
    OppRegIdExistError: false, 
    OppRegIdExistErrorMessage:[], 
    OppRegIdExistSuccess: false, 
    OppRegIdExistSuccessMessage: [],
    }
  },
  clearInternalAccount (state) {
    state.newAwsAcctInternalClient = {
      ...state.newAwsAcctInternalClient,
      landing: true,
      registrationStep: 'internaltype', // ie, listing, validation, onboarding, contact
      Customer_Alias:null,
      hasInternalOppregId: null,
      oppId: '',
      OppregIdValidated: false,
      OppRegIdExistLoading: false,
      OppRegIdExistError: false, 
      OppRegIdExistErrorMessage:[], 
      OppRegIdExistSuccess: false, 
      OppRegIdExistSuccessMessage: [],
      workloads:[],
      workload: {
        dxcInternalUsedOnly: false,
        // workloadTitle: null,
        // workloadStatus: 'Internal - Tier 1 23% - PPA',
        // customerName: 'DXC Internal',
        sameAsLoggedInUser: false,
        loadingContact: false,
        oppFields: {
          opportunity: {
            Opportunity_Id: null,
            SFDC_Oppty_Name: null,
            SFDC_Sales_Stage: null,
            SignDate: null,
            OpportunityTotalValueUSD: null,
            ESRegion: null,
            Customer_Name: 'DXC Internal',
            Country: null,
            PrimaryESPracticeName: null,
            OpportunityDescription: null,
            OpportunityStatus: null,
            IndustryVertical: null,
            ContractLength: null,
            OpportunityNumber: null,
            Client_ID: null
          },
          account: {
            Client_ID: null,
            Customer_Id: null,
            Customer_Name: null,
            Customer_Region: null,
            Customer_URL: null,
            Customer_Address: null,
            Customer_City: null,
            Customer_State: null,
            Customer_PC: null,
            Industry: null
          },
          requestor: {
            Requestor_Id: null,
            Requestor_First_Name: null,
            Requestor_Last_Name: null,
            Requestor_Phone: null,
            Requestor_Email: null
          },
          header: {
            Oppreg_Header_Notes: null,
            Client_ID: null,
            RFI_RFP: null
          }
        },
        fields: {
          Project_Id: null,
          OppReg_Id: null,
          Registration_Id: null,
          Contact_Id: null,
          Requestor_Id: null,
          SFDC_Id: null,
          Workload_Title: null,
          VMware_Workload: null,
          VMware_License: null,
          VMware_Cust_Deploy: null,
          Workload_type: null,
          PPA_Attestation: null,
          Root_Access: null,
          DXC_Managed_Services: null,
          SaaS: null,
          Initiate_Account_Flag: null,
          Workload_Services_Storage: null,
          Workload_Services_Database: null,
          Workload_Services_App_services: null,
          Workload_Services_Compute: null,
          Workload_Services_Network: null,
          Projected_Monthly_Spend: 0,
          WL_Overall_Objective: null,
          WL_Scope_Bounderies: null,
          WL_App_Transformed: null,
          WL_Next_Pursuit: null,
          OppReg_Project_Notes: null,
          OppReg_Req_Date: null,
          Workload_Status: 'Internal - Tier 1 21% - PPA',
          P_Offering_Agreed: 'Y',
          // answers table
          WL_Q1A: null,
          WL_Q2A: null,
          WL_Q3A: null,
          WL_Q4A: null,
          WL_Q5A: null,
          WL_Q6A: null,
          Attested_By: null,
          DXC_Services: null,
          WL_Q7A: '[]',
          WL_Q8A: null,
          WL_Q9A: null,
          WL_Q10A: null
        },
        contact: {
          Id: null,
          Contact_First_Name: null,
          Contact_Last_Name: null,
          Contact_Email: null,
          Contact_Phone: null
        }
      },
      projectId: '',
      custName: '',
      oppregStatus:'',
      accountRecord: {
        financial: {
          WBS_code: null,
          WBS_expiration_date: null,
          IWO_Reqd: null,
          IWO_Code: null,
          IWO_expiration_date: null,
          awsCredits: null
        },
        onboarding: {
          Onboarding_Id: null,
          Acct_ID: null,
          Acct_Exp_Id: null,
          Financial_Id: null,
          Unique_Agreement_Id: null,
          AcctSecurity_Id: null,
          Customer_Id: null,
          Project_Id: null,
          Contact_Id: null,
          Client_Shortname: null,
          Cust_Shortname: null,
          Customer_Type: null,
          Acct_name: null,
          Onboarding_Status: 'New',
          Acct_DL: null,
          Date_onboarded: null,
          Last_Date_Validated: null,
          Date_Requested_change: null,
          MP_ID: null,
          Previous_MP_ID: null,
          Managed_Svc: null,
          Acct_status: null,
          Acct_Restricted: null,
          Is_MP: null,
          Acct_Description: null,
          Del_Flag: 0,
          Account_Purpose: null,
          AWS_Support_Type: null,
          Specific_Region: null,
          Specific_Location: null,
          Account_Owners: [],
          CloudCheckr_users: [],
          IAM_Users: [],
          Notification_List: [],
          Financial_Owner: [],
          Customer_Regulations: [],
          Comments: null,
          SaaS: null,
          SaaS_Solution: null,
          AWS_Req_Type:null,
          Restricted_Region_Id: null,
          GovCloud_Resource_Account: null
        },
        contact: {
          Id: null,
          Contact_First_Name: null,
          Contact_Last_Name: null,
          Contact_Phone: null,
          Contact_Email: null,
          Contact_Title: null,
          Contact_FullName: null
        },
        newContact: {
          Id: null,
          Contact_First_Name: null,
          Contact_Last_Name: null,
          Contact_Phone: null,
          Contact_Email: null,
          Contact_Title: null,
          Contact_FullName: null
        }
      }
    }
  },
  clearInternalAwsAcctValidation (state) {  
    state.awsAccountValidation = {
      ...state.awsAccountValidation,
      wbsCode: null,
      wbsValidating: false,
      wbsValidationMessage: '',
      wbsCodeValidated: false,
      wbsType: null,
      iwoCode: null,
      iwoValidating: false,
      iwoValidationMessage: '',
      iwoCodeValidated: false,
      agreed: false,
      submitting: false,
      savingForLater: false,
      isPromoCode: null,
      awsCredits: null
    }
  },
  clearInternalAwsOnboarding (state) {
    state.awsAccountOnboarding = {
      ...state.awsAccountOnboarding,
      valid: false,
      Region: false,
      isLocationSpecific: false,
      AWS_Purpose: {
        all: [],
        primary: null,
        other: [],
        poc: {
          q1: null,
          q2: null,
          q3: null,
          q4: null,
          q5: null
        }
      },
      Client_Shortname: null,
      fields: {
        Onboarding_Id: null,
        Acct_ID: null,
        Acct_Exp_Id: null,
        Financial_Id: null,
        Unique_Agreement_Id: null,
        AcctSecurity_Id: null,
        Customer_Id: null,
        Project_Id: null,
        Contact_Id: null,
        Customer_Type: null,
        Client_Shortname: null,
        Cust_Shortname: null,
        Acct_name: null,
        Acct_DL: null,
        Date_onboarded: null,
        Last_Date_Validated: null,
        Date_Requested_change: null,
        MP_ID: null,
        Previous_MP_ID: null,
        Managed_Svc: null,
        Acct_status: null,
        Acct_Restricted: null,
        Is_MP: null,
        Acct_Description: null,
        Del_Flag: 0,
        Account_Purpose: null,
        AWS_Support_Type: null,
        Specific_Region: null,
        Specific_Location: null,
        Account_Owners: [],
        CloudCheckr_users: [],
        IAM_Users: [],
        Notification_List: [],
        Customer_Regulations: [],
        Financial_Owner: [],
        Comments: null,
        AWS_Req_Type:null,
        Restricted_Region_Id: null,
        GovCloud_Resource_Account: null
      }
    }
  },
  clearInternalAwsOnboardingContacts (state) {
    state.awsAccountContact = {
      ...state.awsAccountContact,
      acctOwner: {
        name: null,
        phone: null,
        email: null
      },
      submitting: false,
      submitted: false,
      contactStatus: false,
      contactStatusMsg: null,
      Account_Owners: []
    }
  },
  clearAwsAccountOnboardingPurposes (state) {
    state.awsAccountOnboarding = {
      ...state.awsAccountOnboarding,
      AWS_Purpose: {
        all: [],
        primary: null,
        other: [],
        poc: {
          q1: null,
          q2: null,
          q3: null,
          q4: null,
          q5: null
        }
      }
    }
  },
  setAwsAccountOnboardingSupportTypeAndIsTraining (state) {
    state.awsAccountOnboarding = {
      ...state.awsAccountOnboarding,
      fields: {
        ...state.awsAccountOnboarding.fields,
        AWS_Support_Type: 'Enterprise',
        Is_Training_Account: 'Yes'
      }
    }
  },
  addAccountOwner (state, data) {
    
    let contactName = '';
    let contactEmail = '';

    if (data.type === 'owner') {
      contactName = data.payload.workload.contact.Contact_First_Name + ' ' + data.payload.workload.contact.Contact_Last_Name;
      contactEmail = data.payload.workload.contact.Contact_Email;
    } else if (data.type === 'manager') {
      contactName = data.payload.fields.Manager_Name;
      contactEmail = data.payload.fields.Manager_Email;
    }

    const contactDetails = {
      name: contactName,
      phone: '',
      email: contactEmail
    }
    state.awsAccountContact = {
      ...state.awsAccountContact,
      Account_Owners: [...state.awsAccountContact.Account_Owners, contactDetails]
    }
    console.log('awsAccountContact',state.awsAccountContact)
  },

  addFinanceOwner (state, data) {
    state.newAwsAcctInternalClient = {
      ...state.newAwsAcctInternalClient,
      accountRecord: {
        ...state.newAwsAcctInternalClient.accountRecord,
        onboarding: {
          ...state.newAwsAcctInternalClient.accountRecord.onboarding,
          Financial_Owner: [...state.newAwsAcctInternalClient.accountRecord.onboarding.Financial_Owner, data.fields.Manager_Email]
        }
      }
    }
    console.log('state.newAwsAcctInternalClient', state.newAwsAcctInternalClient)
  },

  setInternalDxcRegion (state, data) {
    state.awsAccountOnboarding.fields.Specific_Region = data
  },
  setInternalCustomer (state, data) {
    state.newAwsAcctInternalClient.custName = data
  },
  setInternalOppregStatus(state,data){
    state.newAwsAcctInternalClient.oppregStatus = data
  },

  addS3FileName(state, fileName) {
    state.awsAccountOnboarding = {
      ...state.awsAccountOnboarding,
      fields: {
        ...state.awsAccountOnboarding.fields,
        S3_Filename: fileName
      }
    }
  },
  addS3FileNameToAccountRecord(state, data) {
    state.newAwsAcctInternalClient = {
      ...state.newAwsAcctInternalClient,
      accountRecord: {
        ...state.newAwsAcctInternalClient.accountRecord,
        onboarding: {
          ...state.newAwsAcctInternalClient.accountRecord.onboarding,
          S3_Filename: data
        }
      }
    }
  },

  setS3File(state, data) {
    state.s3FileUpload = {
      ...state.s3FileUpload,
      item: data
    }
  }


}
